// extracted by mini-css-extract-plugin
export default {"MobileWrapper":"MobileWrapper_MobileWrapper__JGFNQ"};